import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Step1, Step2, Step3 } from '@/pages/registration/investor/steps';
import { BREAKPOINTS, Container, Flex } from '@/ui';
import { Button, StepsProgress } from '@/components';
import { Typography } from 'antd';
import { COLORS } from '@/utils/static';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined } from '@ant-design/icons';

const goNext = (currentStep, navigate) => {
  navigate(`/registration/investor/${++currentStep}`);
};
const goBack = (currentStep, navigate) => {
  let newStep = --currentStep;
  if (newStep < 1) newStep = 1;
  navigate(`/registration/investor/${newStep}`);
};

const InvestorReg = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { page } = useParams();

  const renderStep = useCallback((page) => {
    switch (+page) {
      case 1:
        return (
          <Step1
            stepNumber={page}
            goNext={() => goNext(page, navigate)}
            goBack={() => goBack(page)}
          />
        );
      case 2:
        return (
          <Step2
            stepNumber={page}
            goNext={() => goNext(page, navigate)}
            goBack={() => goBack(page)}
          />
        );
      case 3:
        return (
          <Step3
            stepNumber={page}
            goNext={() => goNext(page, navigate)}
            goBack={() => goBack(page)}
          />
        );
      default:
        return null;
    }
  }, []);

  return (
    <StyledMainRow wrap>
      <StyledContainer>
        <Button
          size='large'
          type='text'
          text={t('Back')}
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        />
      </StyledContainer>

      <Typography.Title
        level={2}
        style={{ textAlign: 'center', fontWeight: '600', color: COLORS.default }}
      >
        {t('Creation account')}
      </Typography.Title>

      <StyledStepsContainer $maxWidth={667} $wide $marginTop={57}>
        <StepsProgress currentStep={page - 1} />
      </StyledStepsContainer>
      {renderStep(page)}
    </StyledMainRow>
  );
};

export default InvestorReg;

const StyledMainRow = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 16px 112px;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding: 80px 24px;
  }
`;

const StyledContainer = styled(Container)`
  position: absolute;
  top: 20px;
  left: 32px;
  width: min-content;
  z-index: 129;
  @media (max-width: ${BREAKPOINTS.md}px) {
    top: 15px;
    left: 24px;
  }
`;

const StyledStepsContainer = styled(Container)`
  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin-top: 28px;
  }
`;
